"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @ts-check

/**
 * @param {V2.ExchangeDataGrouping} _
 * @returns {V2.ExchangePolicyGroupInfo}
 */
function noExchanges(_) {
  // eslint-disable-line no-unused-vars
  return {
    icon: "ban",
    method: "!refund-and-exchange.content.exchange.none.method",
    method_simplified: "!refund-and-exchange.content.exchange.none.method.simplified"
  };
}

exports.default = noExchanges;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy92Mi9leGNoYW5nZXMvbm8tZXhjaGFuZ2VzLmpzIl0sIm5hbWVzIjpbIm5vRXhjaGFuZ2VzIiwiXyIsImljb24iLCJtZXRob2QiLCJtZXRob2Rfc2ltcGxpZmllZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQTs7QUFFQTs7OztBQUlBLFNBQVNBLFdBQVQsQ0FBcUJDLENBQXJCLEVBQXdCO0FBQ3RCO0FBQ0EsU0FBTztBQUNMQyxVQUFNLEtBREQ7QUFFTEMsWUFBUSxtREFGSDtBQUdMQyx1QkFBbUI7QUFIZCxHQUFQO0FBS0Q7O2tCQUVjSixXIiwiZmlsZSI6Im5vLWV4Y2hhbmdlcy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEB0cy1jaGVja1xuXG4vKipcbiAqIEBwYXJhbSB7VjIuRXhjaGFuZ2VEYXRhR3JvdXBpbmd9IF9cbiAqIEByZXR1cm5zIHtWMi5FeGNoYW5nZVBvbGljeUdyb3VwSW5mb31cbiAqL1xuZnVuY3Rpb24gbm9FeGNoYW5nZXMoXykge1xuICAvLyBlc2xpbnQtZGlzYWJsZS1saW5lIG5vLXVudXNlZC12YXJzXG4gIHJldHVybiB7XG4gICAgaWNvbjogXCJiYW5cIixcbiAgICBtZXRob2Q6IFwiIXJlZnVuZC1hbmQtZXhjaGFuZ2UuY29udGVudC5leGNoYW5nZS5ub25lLm1ldGhvZFwiLFxuICAgIG1ldGhvZF9zaW1wbGlmaWVkOiBcIiFyZWZ1bmQtYW5kLWV4Y2hhbmdlLmNvbnRlbnQuZXhjaGFuZ2Uubm9uZS5tZXRob2Quc2ltcGxpZmllZFwiXG4gIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IG5vRXhjaGFuZ2VzO1xuIl19